import { css } from 'lit';

export const voyagePassagePlanOverviewStyles = css`
    :host {
        font-family: MaerskText;
    }

    .content {
        display: flex;
        flex-direction: column;
        margin: 20px;
    }

    h2 {
        font-weight: bold;
        font-size: 16px;
        color: var(--neutrals-grey-02, black);
        margin-top: 80px;
        margin-bottom: 20px;
    }

    h2:first-child {
        margin-top: 20px;
    }

    h3 {
        font-weight: bold;
        font-size: 14px;
        color: var(--neutrals-grey-02, black);
        margin-top: 50px;
        margin-bottom: 5px;
    }

    h2 + h3 {
        margin-top: 0;
    }

    p {
        margin: 0;
        color: var(--neutrals-grey-02, black);
        font-size: 14px;
        max-width: 1120px;
    }

    .pre-wrap {
        white-space: pre-wrap;
    }

    p + p {
        margin-top: 20px;
    }

    .ports {
        display: flex;
        flex-direction: row;
    }

    .port {
        display: flex;
        flex-direction: column;
        margin-right: 120px;
    }

    .buttons {
        display: flex;
        align-items: center;
        position: relative;
        box-sizing: border-box;
        height: 96px;
        border-top: 1px solid var(--neutrals-grey-07, grey);
    }
    
     .buttons.app-offline {
        display: flex;
        flex-direction: column;
        align-items: start;
        position: relative;
        box-sizing: border-box;
        height: 130px;
        border-top: 1px solid var(--neutrals-grey-07, grey);
        padding: 30px 0;
    }
    .buttons.app-offline .logLinkText {
            margin-left: 30px;
        }

    .buttons[approved] {
        border: 1px solid var(--approved-plan-color, green);
    }

    .buttons[approved]::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background-color: var(--approved-plan-color, green);
        opacity: 0.07;
        z-index: -1;
    }

    button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0;
        margin-left: 20px;
        margin-bottom: 15px;
        height: 32px;
        width: 96px;
        font-size: 16px;
        font-family: MaerskText;
        outline: none;
        border-radius: 3px;
        background: var(--neutrals-grey-10, white);
        color: var(--neutrals-grey-02, black);
        border: 1px solid var(--neutrals-grey-06, grey);
    }

    svg {
        display: block;
        fill: currentColor;
        width: 16px;
        height: 16px;
        margin: 10px;
    }

    .largeButton {
        margin-top: 20px;
        margin-bottom: 20px;
        height: 56px;
        width: 217px;
    }

    .blueButton {
        background: var(--primary-blue-05, blue);
        color: var(--neutrals-grey-10, white);
        border: none;
    }

    #approve-btn-not-allowed-text {
        display: none;
        width: 550px;
        font-weight: bold;
        margin: 0 0 0 10px;
        color: var(--feedback-danger, red);
        font-size: 12px;
        font-family: MaerskText;
    }

    #approve-btn-not-allowed-text[show] {
        display: block;
    }

    .approveText {
        margin: 15px;
        margin-left: 20px;
        font-size: 12px;
        color: var(--neutrals-grey-02, black);
    }

    .approvedText {
        display: inline-flex;
        align-items: center;
        color: var(--approved-plan-color, green);
        font-size: 16px;
    }
    
    .errorText {
        display: inline-flex;
        align-items: center;
        color: var(--feedback-danger, red);
        font-size: 16px;
    }

    .approving {
        display: flex;
        margin-left: 75px;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        color: var(--neutrals-grey-02, black);
    }

    .blueButton[disabled] {
        color: var(--neutrals-grey-02);
        border: 1px solid var(--neutrals-grey-06, grey);
        background-color: white;
        filter: opacity(0.5);
    }

    voyage-spinner {
        height: 25px;
        width: 25px;
        margin-bottom: 5px;
        --voyage-spinner-stroke-width: 3px;
        --voyage-spinner-bg-color: var(--neutrals-grey-07, grey);
    }
    .infoContanier {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 100%;
        border-top: 1px solid var(--neutrals-grey-07, grey);
    }    
    .infoContanier.offlinePlan {
        width: 100%;
        padding: 20px 0;
    }
    .infoContanier.basicPlan {
        padding: 20px;
    }    
    .infoContanier.offlinePlan .icon .network-status-icon svg {
       width: 27px;
        height: 27px;
        color: #b80012;
        margin: 0 20px 0 0;
    }
    .infoContanier.offlinePlan .text .offlineText, .infoContanier.basicPlan .text .basicText {
        color:#997303
    }
    .infoContanier.offlinePlan .text .syncText {
        color: #545454;
        margin-top: 5px;
    }
`